import { WINDOWS, GAME_ID, REDUX_ACTIONS } from 'a/rhymeTime/data/constants';

export const initialState = {
  currentActivityWindow: WINDOWS.PROGRESS,
};

const activityReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_ACTIVITY_WINDOW:
      return {
        ...state,
        currentActivityWindow: action.payload.window,
      };
    default:
      return state;
  }
};

export default activityReducer;
